import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchConversionCampaignCommissionsThunk, fetchConversionCampaignsThunk } from '../../redux-stores/slices/conversionCampaignSlice';
import { AppDispatch, RootState } from '../../redux-stores/store';
import InfiniteScroll from 'react-infinite-scroll-component';
import Masonry from 'react-masonry-css';
import moment from 'moment';
import { getStatusColorClass } from '../../utils/helpers';
import { ConversionCampaignCommissionStatusLabel } from '../../types/conversions';
const breakpointColumnsObj = {
    default: 2,
    600: 1,
};
const ConversionCampaignCommissions = () => {

    const dispatch = useDispatch<AppDispatch>();

    const navigate = useNavigate();

    const { list: commissions, page, has_more } = useSelector(
        (state: RootState) => state.conversionCampaigns.commissions
    );

    const commissionsLoading = useSelector((state: RootState) => state.conversionCampaigns.commissionsLoading);

    const nextPage = () => {
        if (has_more) {
            const nextPageNumber = page + 1;
            fetchConversionCampaignsCommissions(nextPageNumber)
        }

    }

    const fetchConversionCampaignsCommissions = useCallback(async (pageNumber: number) => {
        await dispatch(fetchConversionCampaignCommissionsThunk({ page: pageNumber }));
    }, [dispatch]);

    useEffect(() => {
        fetchConversionCampaignsCommissions(1);
    }, [fetchConversionCampaignsCommissions])

    return (
        <div className=''>
            <InfiniteScroll
                dataLength={commissions.length} // Number of currently loaded campaigns
                next={nextPage}
                hasMore={has_more} // True if there are more campaigns to load
                loader={<></>}
                className='d-flex flex-column gap-3 p-3'
            >
                {
                    commissions.map((commission, i) => {
                        return (
                            <div className="campaign-commission-card app-card" key={i}>
                                <div className="commissions-brand-section">
                                    <div className="commissions-brand-logo bg-image bgc-white" style={{ backgroundImage: `url(${commission.campaign?.img_url})` }}></div>
                                    <span className="commissions-brand-name">{commission.campaign?.name}</span>
                                </div>
                                <div className="commissions-stat-section app-sub-card bg-light-gray">
                                    <div className="commissions-stat-item">
                                        <span className="commissions-stat-item-label">Date</span>
                                        <span className="commissions-stat-item-value">
                                            {moment(commission.created_at).format("DD MMM")}
                                        </span>
                                    </div>
                                    <div className="commissions-stat-item">
                                        <span className="commissions-stat-item-label">Total Earning</span>
                                        <span className="commissions-stat-item-value">₹{commission.commission_amount}</span>
                                    </div>
                                    <div className="commissions-stat-item">
                                        <span className="commissions-stat-item-label">Status</span>
                                        <span className={`commissions-stat-item-value ${getStatusColorClass(commission.status)}`}>{ConversionCampaignCommissionStatusLabel[commission.status] || commission.status}</span>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
                {
                    !commissionsLoading && commissions.length === 0 &&
                    <div className="d-flex w-100 justify-content-center align-items-center my-5">
                        <div className="length-zero my-4">
                            <h3>
                                No earnings yet!
                            </h3>
                        </div>
                    </div>
                }
            </InfiniteScroll>
        </div>
    )
}

export default ConversionCampaignCommissions